import {Injectable} from '@angular/core';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';
import {ClienteUsuarioModel} from '../../models/vmi-clienteUsuarioModel';

@Injectable({
  providedIn: 'root'
})
export class VmiClienteUsuarioService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.administracion;
  }

  getClientesByUsuario(innIdUsuario: number) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.clientes + `-usuario/usuario/${innIdUsuario}`);
  }

  saveClienteUsuario(innListObj: ClienteUsuarioModel[]) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioUrl.clientes + `-usuario/usuario`, innListObj);
  }

  deleteClienteUsuario(innIdUsuCliente: number) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.clientes + `-usuario/usuario/${innIdUsuCliente}`);
  }

  deleteAllClienteUsuario(innIdUsuario: number) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.clientes + `-usuario/usuario/all/${innIdUsuario}`);
  }

}
